export const PORTFOLIO_SHELL_SNAPSHOT_KEY = 'profile-portfolio-shell-snapshot';

export const isLoggedInFromAccessType = (accessType: string | undefined): boolean =>
  Boolean(accessType) && accessType !== 'anonymous';

export const readAccessTypeFromCookieString = (cookieHeader: string): string | undefined => {
  const cookieMatch = cookieHeader.match(/(?:^|; )bz_access_type=([^;]*)/);
  if (!cookieMatch) {
    return undefined;
  }
  try {
    return decodeURIComponent(cookieMatch[1]);
  } catch {
    return cookieMatch[1];
  }
};

export const getPortfolioShellFromCookieString = (cookieHeader: string): 'marketing' | 'workspace' =>
  isLoggedInFromAccessType(readAccessTypeFromCookieString(cookieHeader)) ? 'workspace' : 'marketing';

export const snapshotHasHoldings = (raw: string | null): boolean => {
  if (!raw) {
    return false;
  }
  try {
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') {
      return false;
    }
    const snapshot = parsed as Record<string, unknown>;
    return snapshot.version === 1 && snapshot.hasHoldings === true;
  } catch {
    return false;
  }
};

export const applyPortfolioShellDocumentAttributes = (): void => {
  const root = document.documentElement;
  root.setAttribute('data-portfolio-shell', getPortfolioShellFromCookieString(document.cookie));
  try {
    if (snapshotHasHoldings(localStorage.getItem(PORTFOLIO_SHELL_SNAPSHOT_KEY))) {
      root.setAttribute('data-portfolio-has-holdings', '');
    } else {
      root.removeAttribute('data-portfolio-has-holdings');
    }
  } catch {
    root.removeAttribute('data-portfolio-has-holdings');
  }
};

export const markPortfolioShellReady = (): void => {
  document.documentElement.setAttribute('data-portfolio-ready', '');
};

export const clearPortfolioShellDocumentAttributes = (): void => {
  const root = document.documentElement;
  root.removeAttribute('data-portfolio-shell');
  root.removeAttribute('data-portfolio-ready');
  root.removeAttribute('data-portfolio-has-holdings');
};

export const PORTFOLIO_SHELL_BOOT_SCRIPT = `(function(){var r=document.documentElement,c=document.cookie||'',m=c.match(/(?:^|; )bz_access_type=([^;]*)/),a='';if(m){try{a=decodeURIComponent(m[1])}catch(e){a=m[1]}}r.setAttribute('data-portfolio-shell',a&&a!=='anonymous'?'workspace':'marketing');try{var s=localStorage.getItem('${PORTFOLIO_SHELL_SNAPSHOT_KEY}');if(s){var p=JSON.parse(s);if(p&&p.version===1&&p.hasHoldings===true){r.setAttribute('data-portfolio-has-holdings','')}}}catch(e){}})();`;
